import { Context, type Effect, Layer, type Scope } from "effect";
import type { EditorDocumentIdentity } from "./documents-model.ts";
import type { EditorProject, EditorProjectFailure } from "./project-service.ts";
import type { EditorWidgetCallbacks } from "./widget-service.ts";
import type { ImmutableRegistryFailure } from "../tabs/registry-model.ts";
export type EditorViewFailure = EditorProjectFailure | ImmutableRegistryFailure;
export interface EditorViewBinding {
  readonly identity: object;
  readonly target: EditorDocumentIdentity;
  readonly project: EditorProject;
}
export interface EditorViewInitial {
  readonly target: EditorDocumentIdentity;
  readonly currentFile: string | undefined;
}
export interface EditorViewSession {
  readonly bind: (target: EditorDocumentIdentity) => Effect.Effect<EditorViewBinding, EditorViewFailure, Scope.Scope>;
  readonly update: (binding: EditorViewBinding, currentFile: string | undefined) => Effect.Effect<void, EditorViewFailure>;
}
export class EditorViews extends Context.Service<EditorViews, {
  readonly open: (key: string, container: HTMLElement, callbacks: () => EditorWidgetCallbacks, initial?: EditorViewInitial) => Effect.Effect<EditorViewSession, EditorViewFailure, Scope.Scope>;
}>()("workerstation/frontend/EditorViews") {
}
export const EditorViewsTest = (ports: typeof EditorViews.Service) => Layer.succeed(EditorViews, ports);
